import { Routes } from '@front-app/constants/routes';
import { Content, ContentType } from '@front-app/services/GroupsApi/DiscussionModel';
import VueRouter, { Route } from 'vue-router';

export interface UseContentRouting {
	displayInNewTab(content: Content, route: Route, e: Event): void;
}

export const useContentRouting = (router: VueRouter): UseContentRouting => {
	const displayInNewTab = (content: Content, route: Route, e: Event) => {
		e.preventDefault();
		const theUrl = getUrlForContent(content, route, router);
		window.open(theUrl.href, '_blank');
	};

	return {
		displayInNewTab,
	};
};

function getUrlForContent(content: Content, route: Route, router: VueRouter) {
	if (content.type === ContentType.DISCUSSION) {
		return router.resolve({
			name: Routes.GROUP_DISCUSSION,
			params: {
				discussionId: content.id,
				groupId: content.groupId,
			},
		});
	}
	// If we are on the content page, retain the existing parameters and query
	if (route.name && route.name === Routes.GROUP_CONTENT) {
		return router.resolve({
			params: {
				...route.params,
				groupId: content.groupId,
			},
			query: {
				...route.query,
				showContent: content.id,
			},
		});
	}
	return router.resolve({
		name: Routes.GROUP_CONTENT,
		params: {
			groupId: content.groupId,
		},
		query: { showContent: content.id },
	});
}
